import React, { ReactNode, useCallback, useEffect } from "react";
import ReactDOM from 'react-dom';
import Markup from '../../markup';
import { useSpring, config } from 'react-spring';
import { useDrag } from 'react-use-gesture';

type ModalWrapperType = {
    modalOnToogle:(state:boolean)=> void,
    modalStatus:boolean,
    children:ReactNode
}

const Wrapper = ({children}) => {
    const modalRoot = document.getElementById('global-modal-container')
    return ReactDOM.createPortal(children, modalRoot);
}

function ModalWrapper({modalOnToogle, modalStatus, children}:ModalWrapperType){

    useEffect(() => {
        modalStatus &&  openBox();
    },[modalStatus])

    const browserHeight = window.innerHeight * 1;
    const [{ y }, set] = useSpring(() => ({ y: browserHeight }));

    // @ts-ignore
    const bind = useDrag(({ cancel, canceled, last, vxvy: [, vy], movement: [mx, my] }) => {
      if (my < -70) cancel()
      if (last) {
        const isClosing = my > browserHeight * 1 || vy > 1;
        isClosing ? closeBox(vy) : openBox({ canceled })
      } else set({ y: my, immediate: true })
    }, { filterTaps: true, bounds: { top: 0 }, rubberband: true })

    const openBox = async ({ canceled = false } = {}) => {
        await set({ y: 0, immediate: false, config: canceled ? config.wobbly : config.stiff })
    }
    
    const closeBox = async (velocity = 2) => {
        await set({ y: browserHeight, immediate: false, config: { ...config.stiff, velocity } });
        modalOnToogle(false);
    }
  

    return(
    <Wrapper>
        <Markup.Global.SelectBox.MobileContainer
            className="sheet"
            style={{
                transform: y.to(y => `translate3d(0,${y}px,0)`)
            }}
            {...bind()}
        >
            <Markup.Global.SelectBox.MobileContentContainer>
                {children}
            </Markup.Global.SelectBox.MobileContentContainer>
        </Markup.Global.SelectBox.MobileContainer>

        <Markup.Global.SelectBox.MobilePlaceholder
            // @ts-ignore
            style={{ opacity: y.to([0, browserHeight], [0.6, 0], 'clamp') }}
            onClick={() => closeBox()}
        />
    </Wrapper>
    )
}

export default ModalWrapper;